<template>
    <div>    
        <footer class="footer" :style="computedBackground">
            <div class="content has-text-centered">

                <div class="columns box2">
                    <div class="column aux-column"></div>
                    
                    <div class="column">
                        <img :src="logo_url" class="footer-logo"/>
                    </div>

                    <div class="column" id="title-policy">
                        <div>
                            <div class="title-align">
                                <div class="footer-title" v-if="footer.right_title" :style="computedFont">
                                    <p>{{ footer.right_title }}:</p>
                                </div>
                                
                                <div>
                                    <router-link v-if="legal.privacy_policy_url" :style="computedPrimaryColor" :to="{ name: 'privacy' }">Política de privacidade</router-link>
                                    <span v-if="legal.privacy_policy_url && legal.terms_url" :style="computedPrimaryColor" class="mx-1">e</span>
                                    <router-link v-if="legal.terms_url" :style="computedPrimaryColor" :to="{ name: 'terms' }">Termos de uso</router-link>
                                </div>


                                </div>
                        </div>
                    </div>

                </div>

            </div>
        </footer>
        <footer class="footer pa-1 cplug-footer">
            <div class="content has-text-centered">
                <p class="has-text-light">
                    <a href="https://connectplug.com.br">
                        <img :src="require('@/assets/cplug.png')"/>
                    </a>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Footer',
    computed: {
        ...mapGetters({
            logo_url        : 'company/logo_url',
            background_color: 'company/background_color',
            font_color      : 'company/font_color',
            footer          : 'company/footer',
            legal           : 'company/legal',
            faq             : 'company/faq',
            frontendUrl     : 'company/frontend_domain',
            primary_color   : 'company/primary_color'
        }),

        computedBackground() {
            return {
                'background-color': this.background_color,
            }
        },

        computedFont() {
            return {
                'color': this.font_color,
            }
        },

        computedPrimaryColor() {
            return {
                'color': this.primary_color,
            }
        },
    },
}
</script>

<style lang="scss" scoped>
    .cplug-footer {
        background-color: #2d2d2d;

        img {
            max-width: 250px;
        }
    }

    .footer-logo {
        max-width: 184px;
    }
    .aux-column{
        display: none;
    }
    
@media screen and (min-width: 769px) {
    .columns{
        flex-direction: row-reverse;
    }
   .aux-column{
       display: flex;
   }
   #title-policy{
       display: flex;
       align-items: center;
       justify-content: center;
   }
   .title-align{
       text-align: justify;
   }
}
</style>